export default __webpack_public_path__ + "static/media/avatar_profile.5a14f6d3.jpg";